import type { WebhookModel } from './types'

export type ApiLogModel = {
  actioned_by_id?: number,
  api_type?: string,
  cache_key: number,
  dates?: {
    created?: {
      date_time: string,
    },
    updated?: {
      date_time: string,
    },
  },
  entity_id: number,
  entity_type: string,
  http_method?: string,
  event: string,
  id: number,
  notes?: string,
  notification_sent?: boolean,
  request_body?: string,
  response_body?: string,
  status_code?: number,
  success: boolean,
  url: string,
  webhook_id: number,
  webhook?: WebhookModel,
}

export type ApiLogRequestOptions = {
  include_api_actioned_by_user?: boolean,
  include_api_log_webhook?: boolean,
  skipLoadedForKeysCheck?: boolean,
  success?: boolean,
}

const state = {
  id: null,
  notes: '',
}

export const requiredFields = []

export default state
